import { z } from "zod";

import i18n from "@/i18n";
import { SLUG_REGEX } from "@/lib/slug";

/**
 * Shared validation schema for site identity fields. Used by the create
 * wizard; editing happens inline per-section on the site detail page.
 * A factory so the messages follow the active UI language; rebuild it
 * (e.g. useMemo keyed on i18n.language) when the language changes.
 */
export function buildSiteFormSchema() {
  return z
    .object({
      name: z.string().trim().min(1, i18n.t("siteForm.nameRequired")).max(100),
      displayName: z.string().max(200).optional(),
      slug: z.string().trim().regex(SLUG_REGEX, i18n.t("siteForm.slugFormat")),
      language: z.string().min(1),
      expiresAt: z.date().nullable(),
      archived: z.boolean().optional(),
    })
    .refine((data) => data.expiresAt === null || data.expiresAt.getTime() > Date.now(), {
      message: i18n.t("siteForm.expirationFuture"),
      path: ["expiresAt"],
    });
}

export type SiteFormValues = z.infer<ReturnType<typeof buildSiteFormSchema>>;
